import LucideIcon from '@/components/atom/Icons/LucideIcon';
import PATH from '@/src/routes/path';
import { NavGroup } from '@/components/organism/SideNav/types';
import { NAV_CONST } from '@/src/constants/nav';
import LocalIcon from '@/components/atom/Icons/LocalIcon';
import SupportSvg from '@/assets/icons/icon-support-menu.svg';
import CustomersSvg from '@/assets/icons/icon-customers.svg';
import RecyclingSvg from '@/assets/icons/icon-recycling-menu.svg';
import AdministratorSvg from '@/assets/icons/icon-administrator-menu.svg';
import MarketingSvg from '@/assets/icons/icon-marketing-menu.svg';
import ContentSVG from '@/assets/icons/icon-content-menu.svg';
import CreditSVG from '@/assets/icons/icon-credit-menu.svg';
import CommunitySVG from '@/assets/icons/icon-community-menu.svg';
import AppSVG from '@/assets/icons/globe-asia-australia.svg';

export const operationNavGroup = (): NavGroup => {
  return {
    groupLabel: NAV_CONST.serviceOperation,
    groupList: [
      {
        id: 'customers',
        label: NAV_CONST.customersManagement,
        icon: <LocalIcon iconSrc={CustomersSvg} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.normalCustomersManagement,
            path: PATH.NORMAL_CUSTOMER_LIST,
          },
          {
            itemLabel: NAV_CONST.businessCustomersManagement,
            path: PATH.BUSINESS_CUSTOMER_LIST,
          },
        ],
      },
      {
        id: 'recycling',
        label: NAV_CONST.recyclingManagement,
        icon: <LocalIcon iconSrc={RecyclingSvg} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.recyclingRequests,
            path: PATH.RECYCLING_REQUESTS_LIST,
          },
          {
            itemLabel: NAV_CONST.recyclingProductManagement,
            path: PATH.RECYCLING_PRODUCT_LIST,
          },
          {
            itemLabel: NAV_CONST.recyclingCouponManagement,
            path: PATH.RECYCLING_COUPON_LIST,
          },
          {
            itemLabel: NAV_CONST.recyclingPackageProducts,
            path: PATH.RECYCLING_PACKAGE_PRODUCTS,
          },
        ],
      },
      {
        id: 'community',
        label: NAV_CONST.community,
        icon: <LocalIcon iconSrc={CommunitySVG} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.communityManagement,
            path: PATH.COMMUNITY_LIST,
          },
          {
            itemLabel: NAV_CONST.communityReportManagement,
            path: PATH.COMMUNITY_REPORT_LIST,
          },
        ],
      },
      {
        id: 'app',
        label: '얼스 앱 관리',
        icon: <LocalIcon iconSrc={AppSVG} iconSize={20} />,
        itemList: [
          {
            itemLabel: '홈 퀵메뉴 관리',
            path: PATH.APP_HOME_CONTENT_LIST,
          },
        ],
      },
      {
        id: 'contents',
        label: NAV_CONST.content,
        icon: <LocalIcon iconSrc={ContentSVG} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.magazineManagement,
            path: PATH.MAGAZINE_LIST,
          },
          {
            itemLabel: NAV_CONST.entryManagement,
            path: PATH.ENTRY_LIST,
          },
          {
            itemLabel: NAV_CONST.donationManagement,
            path: PATH.DONATION_LIST,
          },
          {
            itemLabel: NAV_CONST.challengeManagement,
            path: PATH.CHALLENGE_LIST,
          },
        ],
      },
      {
        id: 'credit',
        label: NAV_CONST.earthCredit,
        icon: <LocalIcon iconSrc={CreditSVG} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.creditManagement,
            path: PATH.CREDIT_LIST,
          },
        ],
      },
      {
        id: 'marketing',
        label: NAV_CONST.marketing,
        icon: <LocalIcon iconSrc={MarketingSvg} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.pushAlarmInfoManagement,
            path: PATH.PUSH_ALARM_LIST,
          },
          {
            itemLabel: NAV_CONST.mainBannerManagement,
            path: PATH.MAIN_BANNER_LIST,
          },
          {
            itemLabel: NAV_CONST.subBannerManagement,
            path: PATH.SUB_BANNER_LIST,
          },
          {
            itemLabel: NAV_CONST.partnershipCompanies,
            path: PATH.PARTNERSHIP_COMPANIES_LIST,
          },
          {
            itemLabel: NAV_CONST.partnershipLink,
            path: PATH.PARTNERSHIP_LINKS_LIST,
          },
        ],
      },
    ],
  };
};

export const systemNavGroup = (): NavGroup => {
  return {
    groupLabel: NAV_CONST.systemManagement,
    groupList: [
      {
        id: 'supportCustomer',
        label: NAV_CONST.supportCustomer,
        icon: <LocalIcon iconSrc={SupportSvg} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.notice,
            path: PATH.NOTICE_LIST,
          },
          {
            itemLabel: NAV_CONST.inquiry,
            path: PATH.INQUIRY_LIST,
          },
          {
            itemLabel: NAV_CONST.faq,
            path: PATH.FAQ_LIST,
          },
        ],
      },
      {
        id: 'administrator',
        label: NAV_CONST.administrator,
        icon: <LocalIcon iconSrc={AdministratorSvg} iconSize={20} />,
        itemList: [
          {
            itemLabel: NAV_CONST.administratorManagement,
            path: PATH.ADMINISTRATOR_LIST,
          },
        ],
      },
    ],
  };
};

export const testNavGroup = (): NavGroup => {
  return {
    groupLabel: '테스트 그룹',
    groupList: [
      {
        id: 'test',
        label: '테스트 페이지 리스트',
        icon: <LucideIcon name="Users" size={20} />,
        itemList: [
          {
            itemLabel: 'CK에디터 테스트',
            path: PATH.CK_EDITOR_TEST,
          },
          {
            itemLabel: '필터 테스트',
            path: PATH.FILTER_TEST,
          },
          {
            itemLabel: '테이블 테스트',
            path: PATH.TABLE_TEST,
          },
          {
            itemLabel: 'Form 테스트',
            path: PATH.FORM_TEST,
          },
          {
            itemLabel: 'DnD 테스트',
            path: PATH.DND_TEST,
          },
          {
            itemLabel: 'Tabs 테스트',
            path: PATH.TABS_TEST,
          },
        ],
      },
    ],
  };
};
